import { ReactSVG } from "react-svg";
import styled from "styled-components";

const Container = styled.div`
  height: max(130px, fit-content);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  border-radius: 10px;
  box-shadow:
    0px 5px 15px rgba(0, 0, 0, 0.05),
    0px 1px 4px rgba(0, 0, 0, 0.25);

  .caret-right-button {
    min-width: unset !important;
    padding: 4px !important;
  }
`;

const Name = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

const CaretRight = styled(ReactSVG)`
  > :first-child {
    width: 20px;
    height: 20px;
    svg {
      width: 100%;
      height: 100%;
      
      path {
        fill: #002951;
      }
    }
  }
`;

export { Container, Name, CaretRight };